'use client'

import NextTopLoader from 'nextjs-toploader'
import { getCookie } from 'shared/libs/storage/cookie'

import { globalStyles } from 'shared/config/styles/globalStyles'

export function NextTopLoaderLayout() {
  const isWebview = getCookie('isWebview')

  if (isWebview) return null

  return (
    <NextTopLoader
      showSpinner={false}
      color={globalStyles['--brand-300']}
      height={4}
    />
  )
}
